import { APP_NAME } from '@config';
import { lazy } from 'react';
const LeadListView = lazy(() => import('@custom/insurance/leads/views/LeadListView'));
const ClientDashboardLayout = lazy(() => import('@custom/insurance/customer/views/ClientDashboardLayout'));
// ONLY protected, core system routes go here
const InsuranceRoutes = [
  {
    path: '/leads',
    skipPermission: true,
    element: <LeadListView />,
  },
  {
     path: "/customer/:customer_id",
     element: <ClientDashboardLayout />,
     seo: {
       title: `Customers | ${APP_NAME}`,
       description:
         `Manage customer profiles, communication, and business history in one place.`
     }
   },
];
export default InsuranceRoutes;